import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { ConfigProvider } from 'antd';
import locale from 'antd/locale/pt_BR';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { lazy, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import GlobalStyles from '../assets/styles/global';
import { LoadingScreen } from '../components/LoadingScreen';
import { AuthProvider } from '../contexts/AuthContext';
import { CustomThemeProvider } from '../contexts/ThemeContext';
import { UserDataProvider } from '../providers/userData';

dayjs.locale('pt-br');

const Appbar = lazy(() =>
	import('../components/Appbar').then((module) => ({ default: module.Appbar }))
);
const Router = lazy(() => import('../routes/index').then((module) => ({ default: module.Router })));

ModuleRegistry.registerModules([AllCommunityModule]);

export function App() {
	return (
		<AuthProvider>
			<UserDataProvider>
				<CustomThemeProvider>
					<ConfigProvider
						locale={locale}
						theme={{
							token: {
								colorTextPlaceholder: '#999'
							},
							components: {
								Button: {
									colorTextDisabled: '#999',
									colorBgContainerDisabled: '#e0e0e0',
									borderColorDisabled: '#d0d0d0'
								}
							}
						}}
					>
						<GlobalStyles />

						<Suspense fallback={<LoadingScreen isVisible />}>
							<BrowserRouter>
								<Appbar />
								<Router />
							</BrowserRouter>
						</Suspense>
					</ConfigProvider>
				</CustomThemeProvider>
			</UserDataProvider>

			<ToastContainer position='bottom-center' />
		</AuthProvider>
	);
}
